import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=66940aea&scoped=true"
import script from "./TableBase.vue?vue&type=script&lang=js"
export * from "./TableBase.vue?vue&type=script&lang=js"
import style0 from "./TableBase.vue?vue&type=style&index=0&id=66940aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66940aea",
  null
  
)

export default component.exports